(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["product-page__product"]) return;
  try {
    
const initAdultSgrip = () => document.querySelectorAll('[data-adult-sgrip] video').forEach(video => {
  if (video.dataset.ready) return;
  video.dataset.ready = 'true';
  const phone = window.matchMedia('(max-width: 749px)');
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  let visible = false;
  const load = () => {
    const src = phone.matches ? video.dataset.mobile : video.dataset.desktop;
    if (video.getAttribute('src') === src) return;
    video.muted = true;
    video.src = src;
    video.load();
  };
  const play = () => { if (visible && !reduce.matches && !document.hidden) video.play().catch(() => {}); };
  video.autoplay = !reduce.matches;
  video.controls = reduce.matches;
  load();
  const observer = new IntersectionObserver(entries => {
    visible = entries[0].isIntersecting;
    if (visible) { load(); play(); } else video.pause();
  }, {rootMargin:'100px 0px'});
  observer.observe(video);
  phone.addEventListener('change', () => { if (visible) { load(); play(); } else video.removeAttribute('src'); });
  reduce.addEventListener('change', () => { video.controls = reduce.matches; video.autoplay = !reduce.matches; if (reduce.matches) video.pause(); else play(); });
  document.addEventListener('visibilitychange', () => { if (document.hidden) video.pause(); else play(); });
});
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',initAdultSgrip); else initAdultSgrip();
document.addEventListener('shopify:section:load',initAdultSgrip);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["ss-home-oct26"] && !Shopify.designMode) return;
  try {
    
class SquidSportCarousel {
  constructor(root) {
    if (root.dataset.carouselReady) return;
    root.dataset.carouselReady = 'true';
    this.track = root.querySelector('[data-sport-track]');
    this.previous = root.querySelector('[data-sport-previous]');
    this.next = root.querySelector('[data-sport-next]');
    this.previous.addEventListener('click', () => this.move(-1));
    this.next.addEventListener('click', () => this.move(1));
    this.track.addEventListener('scroll', () => this.update(), {passive:true});
    this.track.addEventListener('keydown', (event) => {
      if (event.target !== this.track) return;
      if (event.key === 'ArrowRight' || event.key === 'ArrowLeft') { event.preventDefault(); this.move(event.key === 'ArrowRight' ? 1 : -1); }
      if (event.key === 'Home' || event.key === 'End') { event.preventDefault(); this.track.scrollTo({left:event.key === 'Home' ? 0 : this.track.scrollWidth,behavior:this.behavior()}); }
    });
    this.track.addEventListener('wheel', (event) => {
      if (!event.shiftKey || Math.abs(event.deltaX) > Math.abs(event.deltaY)) return;
      event.preventDefault(); this.track.scrollLeft += event.deltaY;
    }, {passive:false});
    this.observer = new ResizeObserver(() => this.update());
    this.observer.observe(this.track);
    this.update();
  }
  behavior() { return window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'; }
  move(direction) { this.track.scrollBy({left:direction*Math.max(213,Math.floor(this.track.clientWidth/213)*213),behavior:this.behavior()}); }
  update() { this.previous.disabled = this.track.scrollLeft <= 2; this.next.disabled = this.track.scrollLeft + this.track.clientWidth >= this.track.scrollWidth - 2; }
}
const initSquidSports = () => document.querySelectorAll('[data-sport-carousel]').forEach(root => new SquidSportCarousel(root));
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded',initSquidSports); else initSquidSports();
document.addEventListener('shopify:section:load',initSquidSports);
class SquidProofStrip {
  constructor(root) {
    if (root.dataset.proofReady) return;
    root.dataset.proofReady = 'true';
    const track = root.querySelector('[data-proof-track]');
    const set = root.querySelector('[data-proof-set]');
    const button = root.querySelector('[data-proof-pause]');
    const pauseLabel = button.getAttribute('aria-label');
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
    let paused = reduce.matches, hovered = false, focused = false, visible = false, touched = 0, last = 0, frame = 0, position = 0;
    const clone = set.cloneNode(true);
    clone.setAttribute('aria-hidden', 'true');
    clone.removeAttribute('data-proof-set');
    clone.querySelectorAll('a').forEach(a => a.tabIndex = -1);
    track.appendChild(clone);
    const updateButton = () => {
      button.setAttribute('aria-pressed', String(paused));
      button.setAttribute('aria-label', paused ? button.dataset.resume : pauseLabel);
      button.firstElementChild.textContent = paused ? '▶' : 'Ⅱ';
    };
    const tick = now => {
      if (!root.isConnected) { observer.disconnect(); return; }
      if (last && visible && !document.hidden && !paused && !hovered && !focused && now > touched) {
        position += Math.min(now - last, 50) * .028;
        if (position >= set.offsetWidth) position -= set.offsetWidth;
        track.scrollLeft = position;
      } else position = track.scrollLeft;
      last = now;
      frame = requestAnimationFrame(tick);
    };
    const observer = new IntersectionObserver(entries => { visible = entries[0].isIntersecting; });
    observer.observe(root);
    root.addEventListener('pointerenter', e => { if (e.pointerType === 'mouse') hovered = true; });
    root.addEventListener('pointerleave', () => { hovered = false; });
    root.addEventListener('focusin', () => { focused = true; });
    root.addEventListener('focusout', e => { focused = root.contains(e.relatedTarget); });
    track.addEventListener('pointerdown', () => { touched = performance.now() + 6000; }, {passive:true});
    track.addEventListener('wheel', () => { touched = performance.now() + 6000; }, {passive:true});
    track.addEventListener('keydown', e => {
      if (e.target === track && ['ArrowLeft','ArrowRight'].includes(e.key)) {
        e.preventDefault(); track.scrollLeft += e.key === 'ArrowRight' ? 240 : -240;
      }
    });
    button.addEventListener('click', () => { paused = !paused; updateButton(); });
    reduce.addEventListener('change', () => { paused = reduce.matches; updateButton(); });
    updateButton();
    frame = requestAnimationFrame(tick);
  }
}
const initSquidProof = () => document.querySelectorAll('[data-proof]').forEach(root => new SquidProofStrip(root));
if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initSquidProof); else initSquidProof();
document.addEventListener('shopify:section:load', initSquidProof);


  } catch(e) { console.error(e); }
})();
})();
